exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2CTZv{width:100%;position:relative}._2CTZv,._3nhOc{display:-webkit-box;display:-ms-flexbox;display:flex}._3nhOc{margin:0;margin-right:2px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.DRK7t{width:16px;height:16px;position:absolute;left:15px;top:8px}.jWUNC{width:100%;height:42px}._3Imj3>.jWUNC{padding-left:36px}._2byyi{-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%;height:42px;position:relative}._2byyi input[type=number]{-moz-appearance:textfield}._2byyi input[type=number]::-webkit-inner-spin-button,._2byyi input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}._3nGhT{color:#000;font-size:16px;margin-left:5px;position:absolute;right:0;height:42px;display:-webkit-box;display:-ms-flexbox;display:flex}._-5BW7{border-right:1px solid rgba(0,0,0,.15);width:0;margin:4px 0}.J0LiY{padding-left:8px}._11n11 .input{border:none}", ""]);

// exports
exports.locals = {
	"root": "_2CTZv",
	"title": "_3nhOc questionTitle",
	"icon": "DRK7t",
	"input": "jWUNC input",
	"hasIcon": "_3Imj3",
	"inline": "_2byyi",
	"switch": "_3nGhT",
	"switchDivider": "_-5BW7",
	"singleOptionLabel": "J0LiY",
	"required": "_1_Rl_ required",
	"theme-flat": "_11n11"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/UI/NumberInputWithSelect/NumberInputWithSelect.css
// module id = 1321
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46